import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** J13: also show the notices as browser notifications (asks permission only when turned on). */
    notifyBrowser: boolean;
  }
}

defineSetting({
  key: 'notifyBrowser',
  default: false,
  order: 150,
  menu: { group: 'data', label: 'แจ้งเตือนผ่านเบราว์เซอร์ (พืชสุก บอสโลก รำสำนัก)' },
});
